module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-stone-path-remnants.7e6b08c6.png";